import * as Yup from "yup";
import { stockAdjusterValidationSchema } from "../../../../utilities/stock-count";

export const CountItemValidationSchema = stockAdjusterValidationSchema.shape({
  barcode: Yup.string().required(),
  name: Yup.string().optional(),
});
